import React from 'react'
import { node, bool, func, string } from 'prop-types'

import CheckIcon from '../../../assets/icons/check.inline.svg'

const FilterItem = ({
  isSelected,
  isFocused,
  content,
  itemId,
  onMouseOverItem,
  onSelectItem,
}) => {
  const className = `lc-dropdown__list-item ${isSelected &&
    'lc-dropdown__list-item--selected'} ${isFocused &&
    'lc-dropdown__list-item--focused'}`

  const onClick = () => onSelectItem(itemId)

  return (
    <li
      data-test={itemId}
      className={className}
      onMouseEnter={onMouseOverItem}
      onClick={onClick}
    >
      <div className="lc-dropdown__list-item__content">{content}</div>

      {isSelected && (
        <CheckIcon
          width="15px"
          height="15px"
          className="lc-dropdown__list-item__checkmark"
        />
      )}
    </li>
  )
}

FilterItem.propTypes = {
  isSelected: bool,
  isFocused: bool,
  content: node,
  itemId: string,
  onMouseOverItem: func,
  onSelectItem: func,
}

export default FilterItem
